import { LogOut } from 'lucide-react'
import { NavLink } from 'react-router-dom'
import { useWireAuth } from '../../auth/useWireAuth'

function NavbarUser() {
  const { user, logout } = useWireAuth()

  const displayName = user?.given_name
    ?? user?.name
    ?? user?.email
    ?? 'Unknown User'

  return (
    <div className="flex items-center gap-3">
      <span className="text-sm font-sans text-fg-secondary">
        Good Afternoon, {displayName}
      </span>
      <NavLink
        to="/wire/me"
        className={({ isActive }) =>
          `flex items-center gap-1 rounded px-2 py-1 text-xs font-sans transition-colors ${
            isActive ? 'bg-fill text-fg' : 'text-fg-secondary hover:bg-fill hover:text-fg'
          }`
        }
      >
        My WIRe
      </NavLink>
      <button
        onClick={logout}
        title="Sign out"
        aria-label="Sign out"
        className="flex items-center gap-1 rounded px-2 py-1 text-xs font-sans text-fg-secondary hover:bg-fill hover:text-fg transition-colors"
      >
        <LogOut size={13} aria-hidden="true" />
        Sign out
      </button>
    </div>
  )
}

export default NavbarUser
